import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, HomeIcon } from 'lucide-react';
import { Logo } from './Logo';
const socials = [{
  label: 'HomeSmart NEXT on Facebook',
  icon: FacebookIcon,
  href: 'https://www.facebook.com/nextrealestateteam/'
}, {
  label: 'HomeSmart NEXT on Instagram',
  icon: InstagramIcon,
  href: 'https://www.instagram.com/nextrealestateteam'
}, {
  label: 'HomeSmart NEXT on LinkedIn',
  icon: LinkedinIcon,
  href: 'https://www.linkedin.com/company/nextrealestateteam/'
}];
export function Footer() {
  return <footer className="w-full bg-white" data-id="element-118" data-mp="37xv6falryhh">
      <div className="mx-auto max-w-content px-4 py-12 md:px-8 md:py-14" data-id="element-119" data-mp="3levg4zwzhcf4">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-120" data-mp="3lgosmvua2qv1">
          <div className="max-w-md" data-id="element-121" data-mp="3qf9q4ni5awfs">
            <Logo data-id="element-122" data-mp="29yxe3g083qne" />
            <p className="mt-4 text-[14px] leading-relaxed text-ink-600" data-id="element-123" data-mp="29ydw5zakp29d">
              Serving real estate agents across Arizona, including the Phoenix metro, Scottsdale, Mesa, Gilbert,
              Chandler, Peoria, Prescott, and Tucson.
            </p>
            <p className="mt-4 flex items-start gap-2 text-[13px] leading-snug text-ink-400" data-id="element-124" data-mp="3gapcfgy9ogex">
              <HomeIcon className="mt-[2px] h-4 w-4 shrink-0" aria-hidden="true" data-id="element-125" data-mp="3v7q6vs7ueph3" />
              Equal Housing Opportunity. We support the Fair Housing Act and the Equal Opportunity Act.
            </p>
          </div>

          <div className="flex flex-col gap-6 md:items-end" data-id="element-126" data-mp="82icpt2wkaeu">
            <nav aria-label="Footer" className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-127" data-mp="80xmugrj9fnb">
              <a href="#privacy" className="text-[14px] font-medium text-ink-600 hover:text-ink" data-id="element-128" data-mp="33nlc2qvddj4">
                Privacy Policy
              </a>
              <a href="#terms" className="text-[14px] font-medium text-ink-600 hover:text-ink" data-id="element-129" data-mp="cu0cidt6w4y8">
                Terms
              </a>
              <a href="#lead-form" className="text-[14px] font-medium text-ink-600 hover:text-ink" data-id="element-130" data-mp="qub8twd9qbqs">
                Contact
              </a>
            </nav>

            <ul className="flex gap-2" data-id="element-131" data-mp="tvczxt1gc7fo">
              {socials.map(social => <li key={social.label} data-id="element-132" data-mp="yu7gspfuzlx5">
                  <a href={social.href} target="_blank" rel="noreferrer noopener" aria-label={social.label} className="flex h-10 w-10 items-center justify-center rounded-lg border border-line text-ink-600 transition-colors duration-150 ease-smooth hover:border-ink hover:text-ink" data-id="element-133" data-mp="yv92royexstn">
                    <social.icon className="h-4 w-4" aria-hidden="true" data-id="element-134" data-mp="1hjnw4iw7dixm" />
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 space-y-3 border-t border-line pt-6 text-[12px] leading-relaxed text-ink-400" data-id="element-135" data-mp="1rjeoadxajluj">
          <p data-id="element-136" data-mp="3obx1fbjbcuuc">HomeSmart NEXT is a real estate team affiliated with HomeSmart.</p>
          <p data-id="element-137" data-mp="3t9yg7k9pi800">
            This page is intended for licensed real estate professionals and those pursuing licensure. No income,
            production, or results are promised or implied.
          </p>
          <p data-id="element-138" data-mp="25onb1tw66vrg">© {new Date().getFullYear()} HomeSmart NEXT. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}